import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Dashboard from './pages/Dashboard';
import './styles/App.css';

// Import tool components
import JsonFormatter from './tools/JsonFormatter';
import JwtDecoder from './tools/JwtDecoder';
import Base64Tool from './tools/Base64Tool';
import XmlFormatter from './tools/XmlFormatter';
import UrlEncoder from './tools/UrlEncoder';
import HashGenerator from './tools/HashGenerator';
import QrGenerator from './tools/QrGenerator';
import ColorPicker from './tools/ColorPicker';
import RegexTester from './tools/RegexTester';
import UuidGenerator from './tools/UuidGenerator';
import Base64ImageConverter from './tools/Base64ImageConverter';
import TimestampConverter from './tools/TimestampConverter';
import UrlAnalyzer from './tools/UrlAnalyzer';
import TextDiffChecker from './tools/TextDiffChecker';
import CaseConverter from './tools/CaseConverter';
import TextStatistics from './tools/TextStatistics';
import JsonPathTester from './tools/JsonPathTester';
import LoremIpsumGenerator from './tools/LoremIpsumGenerator';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            {/* Tool routes */}
            <Route path="/json-formatter" element={<JsonFormatter />} />
            <Route path="/jwt-decoder" element={<JwtDecoder />} />
            <Route path="/base64" element={<Base64Tool />} />
            <Route path="/xml-formatter" element={<XmlFormatter />} />
            <Route path="/url-encoder" element={<UrlEncoder />} />
            <Route path="/hash-generator" element={<HashGenerator />} />
            <Route path="/qr-generator" element={<QrGenerator />} />
            <Route path="/color-picker" element={<ColorPicker />} />
            <Route path="/regex-tester" element={<RegexTester />} />
            <Route path="/uuid-generator" element={<UuidGenerator />} />
            <Route path="/base64-image" element={<Base64ImageConverter />} />
            <Route path="/timestamp-converter" element={<TimestampConverter />} />
            <Route path="/url-analyzer" element={<UrlAnalyzer />} />
            <Route path="/text-diff-checker" element={<TextDiffChecker />} />
            <Route path="/case-converter" element={<CaseConverter />} />
            <Route path="/text-statistics" element={<TextStatistics />} />
            <Route path="/json-path-tester" element={<JsonPathTester />} />
            <Route path="/lorem-ipsum-generator" element={<LoremIpsumGenerator />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
